module.exports = __webpack_public_path__ + "assets/smart-asset-facebook.4b40b212.svg";